import * as React from "react";
import type { SVGProps } from "react";
const SvgBin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      fill="currentColor"
      fillRule="evenodd"
      clipPath="url(#bin_svg__a)"
      clipRule="evenodd"
    >
      <path d="M2 7a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1M14 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1" />
      <path d="M7.586 2.586A2 2 0 0 1 9 2h6a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a2 2 0 0 1 .586-1.414M15 4H9v2h6z" />
      <path d="M4.264 6.323A1 1 0 0 1 5 6h14a1 1 0 0 1 .997 1.083L19 19.046A3 3 0 0 1 16 22H8a3 3 0 0 1-3-2.954L4.003 7.083a1 1 0 0 1 .261-.76M6.087 8l.91 10.917L7 19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l.003-.083L17.914 8z" />
    </g>
    <defs>
      <clipPath id="bin_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBin;
